import { VehicleRangeResource, VehicleDefinitionResource, VehicleIdentitySchema } from '../../classes/Api/Vehicle'

export default {
    namespaced: true,
    state: {
        current: new VehicleIdentitySchema(),
        manufacturers: [],
        ranges: [],
        models: [],
        derivatives: []
    },
    mutations: {
        setManufacturers(state, manufacturers) {
            state.manufacturers = manufacturers;
        },
        setRanges(state, ranges) {
            state.ranges = ranges;
        },
        setModels(state, models) {
            state.models = models;
        },
        setDerivatives(state, derivatives) {
            state.derivatives = derivatives;
        },
        setIdentity(state, payload) { 
            let vehicle_type = typeof payload.vehicle_type === 'object' ? 
                payload.vehicle_type.label : 
                payload.vehicle_type;

            state.current.registration = payload.registration;
            state.current.other_registrations = payload.other_registrations ?? []
            state.current.vin = payload.vin;
            state.current.engine_number = payload.engine_number;
            state.current.registration_date = payload.registration_date;
            state.current.year_of_manufacture = payload.year_of_manufacture;
            state.current.plate = payload.plate;
            state.current.is_imported = payload.is_imported;
            state.current.mileage = payload.mileage;
            state.current.manufacturer = payload.manufacturer;
            state.current.model = payload.model;
            state.current.derivative = payload.derivative;
            state.current.body_type = payload.body_type;
            state.current.colour = payload.colour;
            state.current.number_of_doors = payload.number_of_doors;
            state.current.number_of_seats = payload.number_of_seats;
            state.current.transmission_type = payload.transmission_type;
            state.current.fuel_type = payload.fuel_type;
            state.current.emission_class = payload.emission_class;
            state.current.engine_size = payload.engine_size;
            state.current.co2 = payload.co2;
            state.current.owners = payload.owners;
            state.current.specification_id = payload.specification_id;
            state.current.specification_driver = payload.specification_driver;
            state.current.type = state.current.vehicle_type = vehicle_type;
            state.current.list_price = payload.list_price;
            state.current.insurance_group = payload.insurance_group;
            state.current.mpg_combined = payload.mpg_combined;
            state.current.manufacturer_warranty_years = payload.manufacturer_warranty_years;
            state.current.manufacturer_warranty_miles = payload.manufacturer_warranty_miles;
            state.current.tyre_size_front = payload.tyre_size_front;
            state.current.tyre_size_rear = payload.tyre_size_rear;
            state.current.is_new_or_unregistered = payload.is_new_or_unregistered;
            state.current.has_temporary_vin = payload.has_temporary_vin;
            state.current.bedroom_layout = payload.bedroom_layout;
            state.current.end_layout = payload.end_layout;
            state.current.berths = payload.berths;
            state.current.bedrooms = payload.bedrooms;
            state.current.drive_train = payload.drive_train;
            state.current.drive_position = payload.drive_position;
            state.current.interior_trim = payload.interior_trim;
            state.current.interior_colour = payload.interior_colour;
        },
    },
    actions: {
        setIdentityFromManualLookup(context, payload) {
            return new Promise((resolve, reject) => {
                VehicleRangeResource.resolveManufacturer(payload.manufacturer.name).then(response => {
                    let manufacturer = response.data;

                    VehicleRangeResource.resolveModel(manufacturer.id, payload.model.name).then(response => {
                        let model = response.data;

                        if (payload.derivative.code) {
                            VehicleRangeResource.technicalData(payload.derivative.code).then(response => {
                                payload = Object.assign(payload, response.data)

                                payload.manufacturer.id = manufacturer.id;
                                payload.model.id = model.id;
                                payload.model.name = model.name;
                                payload.specification_id = payload.derivative.code;
                                payload.derivative = payload.derivative.name;

                                context.commit('setIdentity', payload);

                                resolve(payload);
                            })
                        } else {
                            payload.manufacturer.id = manufacturer.id;
                            payload.model.id = model.id;
                            payload.model.name = model.name;
                            payload.derivative = payload.derivative.name;

                            context.commit('setIdentity', payload);
                            resolve(payload);
                        }

                    }, error => { reject(); handleApiError(error); });

                }, error => { reject(); handleApiError(error); });
            });
        },
        lookupByVrm(context, payload) {
            return new Promise((resolve, reject) => {
                let query = VehicleDefinitionResource.lookupByVrm(
                    payload.registration, payload.mileage
                );

                query.then(response => {
                    let data = response.data;
                    data.mileage = payload.mileage;

                    context.commit('setIdentity', data);

                    resolve(data);
                }, error => { reject(); handleApiError(error); });
            });
        },
        lookupByVin(context, payload) {
            return new Promise((resolve, reject) => {
                let query = VehicleDefinitionResource.lookupByVin(
                    payload.vin, payload.mileage
                );

                query.then(response => {
                    let data = response.data;
                    data.mileage = payload.mileage;

                    context.commit('setIdentity', data);

                    resolve(data);
                }, error => { reject(); handleApiError(error); });
            });
        },
        loadManufacturers(context, params) {
            return new Promise((resolve, reject) => {
                VehicleRangeResource.manufacturers(params).then(response => {
                    context.commit('setManufacturers', response.data);
                    resolve(response.data);
                }, error => { reject(error); handleApiError(error); });
            })
        },
        loadRanges(context, { manufacturer_id, params }) {
            return new Promise((resolve, reject) => {
                VehicleRangeResource.ranges(manufacturer_id, params).then(response => {
                    context.commit('setRanges', response.data);
                    resolve(response.data);
                }).catch(e => {
                    if (e.response.status !== 404) {
                        handleApiError(e);
                    }

                    reject(e);
                })
            })
        },
        loadModels(context, { range_id, params }) {
            return new Promise((resolve, reject) => {
                VehicleRangeResource.models(range_id, params).then(response => {
                    context.commit('setModels', response.data);
                    resolve(response.data);
                }).catch(e => {
                    if (e.response.status !== 404) {
                        handleApiError(e);
                    }

                    reject(e);
                })
            })
        },
        loadDerivatives(context, { model_id, params }) {
            return new Promise((resolve, reject) => {
                VehicleRangeResource.derivatives(model_id, params).then(response => {
                    context.commit('setDerivatives', response.data);
                    resolve(response.data);
                }, error => { reject(error); handleApiError(error); });
            })
        }
    }
}